import React from "react";
import { ModalBody, Common, Label, Input, Select } from "@lainco/react-toolbox";
import { useUser } from "../lib/userContext";
import { withCrudModal } from "../components/Modal";
import { useCandidates } from "../app/candidatesSlice";
import BankAccount from "../model/BankAccount";

export function BankAccountModalContent({ model, onChange }) {
  const [banks, banksLoading] = useCandidates("banks");
  const [types, typesLoading] = useCandidates("bankAccountTypes");
  const [company, companyLoading] = useCandidates("companies");
  const [currencies, currenciesLoading] = useCandidates("currencies");
  // Check if user is sysadmin
  const user = useUser();
  const isSysAdmin = user?.roles?.includes("System Admin");

  return (
    <ModalBody>
      <Common.Grid cols="1fr 1fr" gap="1em">
        <Label text="Bank">
          <Select value={model.bank?.id} onChangeOption={(x) => onChange({ ...model, bank: x })} options={banks} loading={banksLoading} />
        </Label>
        <Label text="Type">
          <Select value={model.type?.id} onChangeOption={(x) => onChange({ ...model, type: x })} options={types} loading={typesLoading} />
        </Label>
        <Label text="Company">
          <Select
            value={model.company?.id}
            onChangeOption={(x) => onChange({ ...model, company: x })}
            options={company}
            loading={companyLoading}
          />
        </Label>
        <Label text="Currency">
          <Select
            value={model.currency?.id}
            onChangeOption={(x) => onChange({ ...model, currency: x })}
            options={currencies}
            loading={currenciesLoading}
          />
        </Label>
        <Label text="Name" colSpan="2">
          <Input value={model.name} onChange={(x) => onChange({ ...model, name: x })} />
        </Label>
        {isSysAdmin && model.bank?.apiKeys?.length >= 1 && (
          <Common.Row cols="2fr" gap="1em" colSpan="2" style={{ backgroundColor: "#eee", padding: "1em" }}>
            <Label text="External System Id">
              <Input value={model.externalSystemId} onChange={(x) => onChange({ ...model, externalSystemId: x })} />
            </Label>
          </Common.Row>
        )}
      </Common.Grid>
    </ModalBody>
  );
}

export default withCrudModal(BankAccountModalContent, BankAccount, "lg", false);
